import React from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import { professionalAction, userActions } from "../../_actions";
import moment from "moment";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  Divider,
  PageHeader,
  Descriptions,
  message,
  Image,
} from "antd";
import TokenBox from "../Dashboard/token";

class AboutCIMS extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    aboutusList: [],
  };

  componentDidMount() {
    professionalAction.getAboutCIMS().then((res) => {
      this.setState({
        aboutusList: res,
      });
    });
  }

  componentDidUpdate(prevState) {}

  onCityChange = (cityid) => {
    const { user } = this.props;
    if (user && user.cityId && user && user.role === "4") {
      this.props.dispatch(userActions.getAll(cityid, 2));
    }
  };

  getDistrictName = (id) => {
    const { basicDistricts } = this.props;
    if (basicDistricts && basicDistricts.length) {
      return (
        _.filter(basicDistricts, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(basicDistricts, function (o) {
          return o.id === id;
        })[0].DistrictName
      );
    }
  };
  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  render() {
    const { users } = this.props;
    const { user } = this.props;
    const { newsList } = this.props;

    return (
      <div className="col-md-6 col-md-offset-3">
        <div className="site-page-header-ghost-wrapper">
          <PageHeader
            ghost={false}
            onBack={false}
            title="About CMIS   "
            extra={[]}
          ></PageHeader>
        </div>

        <Divider />

        <div>
          {this.state.aboutusList &&
            this.state.aboutusList.map((item) => (
              <>
                <Image width={200} height={200} src={item.uploadedFileUrl} />
                <p>
                  {moment(item.publishedDate && item.publishedDate).format(
                    "DD-MM-YYYY",
                  )}
                </p>
                <h3>{item.descriptions}</h3>
                <Divider />
              </>
            ))}
          {this.props.user.role == "8" && <TokenBox />}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  const { newsList } = professionals;
  return {
    user,
    users,
    newsList,
    professionals,
  };
}

const connectedAboutCIMS = connect(mapStateToProps)(AboutCIMS);
export { connectedAboutCIMS as AboutCIMS };
